import BlogsService from "../services/blogs_service";

// Helper to ensure data availability
const getBlogList = async () => {
  const blogs = await BlogsService.getBlogs();
  if (!blogs || !Array.isArray(blogs)) {
    console.error("Blogs data is not initialized");
    return [];
  }
  return blogs;
};

export const getPublishedBlogs = async () => {
  const blogs = await getBlogList();
  return blogs.filter((post) => post.isPublished === true).reverse();
};

export const getFeaturedPublishedBlogPosts = async () => {
  const blogs = await getBlogList();
  return blogs
    .filter((post) => post.isFeatured === true && post.isPublished === true)
    .slice(-5);
};

export const getPublishedBlogPostBySlugORID = async (postSlug) => {
  if (!postSlug) return null;

  const blogs = await getBlogList();
  const normalizedSlug = postSlug.toString().trim();
  const isNumeric = !isNaN(normalizedSlug);

  const foundPost = blogs.find(
    (post) =>
      post.isPublished === true &&
      (isNumeric 
        ? post.id === parseInt(normalizedSlug) 
        : post.slug === normalizedSlug)
  );

  return foundPost || null; // Return null if not found for safer UI conditional rendering
};

// import { MODEL } from "../model";
 
// export const getPublishedBlogs = async () => {
//   if (!MODEL.data || !Array.isArray(MODEL.data.blogs)) {
//     console.error("MODEL.data.blogs is undefined or not an array");
//     return [];
//   }

//   return MODEL.data.blogs.filter((post) => post.isPublished === true).reverse();
// };

// // 
// export const getFeaturedPublishedBlogPosts = async () => {
//   const response = await MODEL.data.blogs.filter((post) => post.isFeatured === true && post.isPublished === true)
//     .slice(-5); // Get the last 5 featured posts

//   return response || [];
// };


// export const getPublishedBlogPostBySlugORID = async (postSlug) => {
//   if (!postSlug) return []; // Handle empty input

//   const normalizedSlug = postSlug.toString().trim(); // Ensure it's a string
//   const isNumeric = !isNaN(normalizedSlug); // Check if it's a number

//   return MODEL.data.blogs.find(
//     (post) =>
//       post.isPublished === true &&
//       (isNumeric ? post.id === parseInt(normalizedSlug) : post.slug === normalizedSlug)
//   ) || []; // Return null if not found
// };

// import { MODEL } from "../model";
// import BlogsService from "../services/blogs_service";

// // Helper to ensure data availability
// const getBlogList = () => {
//   const blogs = BlogsService.getBlogs();
//   if (!MODEL.data || !Array.isArray(MODEL.data.blogs)) {
//     console.error("MODEL.data.blogs is not initialized");
//     return [];
//   }
//   return MODEL.data.blogs;
// };

// export const getPublishedBlogs = async () => {
//   const blogs = getBlogList();
//   return blogs.filter((post) => post.isPublished === true).reverse();
// };

// export const getFeaturedPublishedBlogPosts = async () => {
//   const blogs = getBlogList();
//   return blogs
//     .filter((post) => post.isFeatured === true && post.isPublished === true)
//     .slice(-5);
// };

// export const getPublishedBlogPostBySlugORID = async (postSlug) => {
//   if (!postSlug) return null;

//   const blogs = getBlogList();
//   const normalizedSlug = postSlug.toString().trim();
//   const isNumeric = !isNaN(normalizedSlug);

//   const foundPost = blogs.find(
//     (post) =>
//       post.isPublished === true &&
//       (isNumeric 
//         ? post.id === parseInt(normalizedSlug) 
//         : post.slug === normalizedSlug)
//   );

//   return foundPost || null; // Return null if not found for safer UI conditional rendering
// };

// // import { MODEL } from "../model";
 
// // export const getPublishedBlogs = async () => {
// //   if (!MODEL.data || !Array.isArray(MODEL.data.blogs)) {
// //     console.error("MODEL.data.blogs is undefined or not an array");
// //     return [];
// //   }

// //   return MODEL.data.blogs.filter((post) => post.isPublished === true).reverse();
// // };

// // // 
// // export const getFeaturedPublishedBlogPosts = async () => {
// //   const response = await MODEL.data.blogs.filter((post) => post.isFeatured === true && post.isPublished === true)
// //     .slice(-5); // Get the last 5 featured posts

// //   return response || [];
// // };


// // export const getPublishedBlogPostBySlugORID = async (postSlug) => {
// //   if (!postSlug) return []; // Handle empty input

// //   const normalizedSlug = postSlug.toString().trim(); // Ensure it's a string
// //   const isNumeric = !isNaN(normalizedSlug); // Check if it's a number

// //   return MODEL.data.blogs.find(
// //     (post) =>
// //       post.isPublished === true &&
// //       (isNumeric ? post.id === parseInt(normalizedSlug) : post.slug === normalizedSlug)
// //   ) || []; // Return null if not found
// // };
